var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconLock = function SvgIconLock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3333 11.6668V15.0002H15.6667V11.6668C15.6667 9.2736 17.6068 7.3335 20 7.3335C22.3932 7.3335 24.3333 9.2736 24.3333 11.6668ZM6.66667 21.0002C6.66667 18.0272 8.82896 15.5592 11.6667 15.0831V11.6668C11.6667 7.06446 15.3976 3.3335 20 3.3335C24.6024 3.3335 28.3333 7.06446 28.3333 11.6668V15.0831C31.1711 15.5592 33.3333 18.0272 33.3333 21.0002V30.6668C33.3333 33.9805 30.647 36.6668 27.3333 36.6668H12.6667C9.35296 36.6668 6.66667 33.9805 6.66667 30.6668V21.0002ZM20 21.6668C19.0795 21.6668 18.3333 22.413 18.3333 23.3335V28.3335C18.3333 29.254 19.0795 30.0002 20 30.0002C20.9205 30.0002 21.6667 29.254 21.6667 28.3335V23.3335C21.6667 22.413 20.9205 21.6668 20 21.6668Z",
    fill: "#C4C4C4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-lock.ba9b54de4de14e966ac68a610f4be4f2.blank.svg";